<template lang="pug">
  div.client-repuestos-section
    div.row-title.d-flex.pb-3
      b-icon-tools.mr-2.title
      h3.title Repuestos y Mano de Obra
    //- Layout con tabla y totales al lado
    .repuestos-layout
      .tabla-section
        b-table(head-variant="light" borderless :items="ovData.productos" :fields="fields" id="repuestos-table" responsive)
          template(#cell(producto)="data")
            .producto-cell
              p.codigo-text COD: {{ data.item.codigo }}
              h5.producto-text {{ data.item.producto }}
      //- Sección de totales con fondo amarillo
      .totales-section
        .resumen-valores
          .valor
            span.data-label Sub-Total:
            span.data-info {{ ovData.subtotal }}
          .valor(v-if="ovData.monto_descuento && ovData.monto_descuento !== '$0' && ovData.monto_descuento !== '$ 0'")
            span.data-label Descuento:
            span.data-info -{{ ovData.monto_descuento.replace('-', '') }}
          .valor
            span.data-label IVA:
            span.data-info {{ ovData.iva }}
          .valor
            span.data-label Costo Envío:
            span.data-info {{ ovData.costo_envio }}
        .total-final
          .valor
            span.total-label TOTAL:
            span.total-value {{ ovData.total }}
</template>

<script>
export default {
  name: 'TabOVRepuestos',
  props: {
    ov: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      fields: [
        { key: 'producto', label: 'Producto' },
        { key: 'cantidad', label: 'Cantidad' },
        { key: 'precio_unitario', label: 'Precio Unitario' },
        { key: 'descuento', label: 'Descuento Total' },
        { key: 'precio_total', label: 'Total' },
      ],
    }
  },

  computed: {
    ovData() {
      const productos = Array.isArray(this.ov.detalle_venta)
        ? this.ov.detalle_venta.map((item) => {
            const totalConDescuento =
              item.precio_total - (item.monto_descuento || 0)
            return {
              codigo: item.parte.part_number || '-',
              producto: item.parte.description || '-',
              cantidad: item.cantidad || '-',
              precio_unitario: item.precio_unitario
                ? this.$options.filters.formatCurrency(item.precio_unitario)
                : '-',
              descuento: item.monto_descuento
                ? `-${this.$options.filters.formatCurrency(
                    item.monto_descuento
                  )}`
                : '-',
              precio_total: totalConDescuento
                ? this.$options.filters.formatCurrency(totalConDescuento)
                : '-',
            }
          })
        : []
      const servicios = Array.isArray(this.ov.servicios)
        ? this.ov.servicios.map((item) => {
            const totalConDescuento =
              item.precio_total - (item.monto_descuento || 0)
            return {
              codigo: item.id || '-',
              producto: item.servicio.nombre || '-',
              cantidad: item.cantidad || '-',
              precio_unitario: item.precio
                ? this.$options.filters.formatCurrency(item.precio)
                : '-',
              descuento: item.monto_descuento
                ? `-${this.$options.filters.formatCurrency(
                    item.monto_descuento
                  )}`
                : '-',
              precio_total: totalConDescuento
                ? this.$options.filters.formatCurrency(totalConDescuento)
                : '-',
            }
          })
        : []
      const productos_y_servicios = [...productos, ...servicios]
      return {
        productos: productos_y_servicios,
        costo_envio: this.ov.costo_envio
          ? this.$options.filters.formatCurrency(this.ov.costo_envio)
          : '$0',
        monto_descuento: this.ov.monto_descuento
          ? this.$options.filters.formatCurrency(this.ov.monto_descuento)
          : '$0',
        subtotal: this.ov.monto_total_neto
          ? this.$options.filters.formatCurrency(this.ov.monto_total_neto)
          : '$0',
        iva: this.ov.valor_iva
          ? this.$options.filters.formatCurrency(this.ov.valor_iva)
          : '$0',
        total: this.ov.monto_total_final
          ? this.$options.filters.formatCurrency(this.ov.monto_total_final)
          : '$0',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}

.row-title {
  align-items: center;
}

.client-repuestos-section {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
}

.repuestos-layout {
  display: flex;
  gap: 1rem;
  align-items: flex-start;

  @media (max-width: 991px) {
    flex-direction: column;
  }
}

.tabla-section {
  flex: 1;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.totales-section {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 180px;

  @media (max-width: 991px) {
    align-self: flex-end;
  }
}

.resumen-valores {
  background-color: rgba(254, 206, 47, 0.15);
  padding: 0.75rem 1rem;
  border-radius: 8px 8px 0 0;
}

.total-final {
  background-color: rgba(254, 206, 47, 0.15);
  padding: 0.75rem 1rem;
  border-radius: 0 0 8px 8px;
  border-top: 1px solid #525252;
}

.valor {
  display: flex;
  justify-content: space-between;
  padding: 2px 0;
}

.data-label {
  font-size: 14px;
  font-weight: 700;
  color: #525252;
}

.data-info {
  font-size: 14px;
  font-weight: 400;
  color: #525252;
  text-align: right;
}

.total-label {
  font-size: 14px;
  font-weight: 700;
  color: $blue-accent;
}

.total-value {
  font-size: 14px;
  font-weight: 700;
  color: $blue-accent;
  text-align: right;
}

.codigo-text {
  font-size: 10px;
  color: #999;
  margin: 0;
  font-weight: 400;
}

.producto-text {
  font-size: 14px;
  color: #23201c;
  margin: 0;
}

.producto-cell {
  text-align: left;
}

::v-deep .table td,
::v-deep .table th {
  text-align: left;
  vertical-align: middle;
  color: #23201c;
}

::v-deep .table td {
  padding: 0.25rem 1rem;
}

::v-deep .table td:first-child,
::v-deep .table th:first-child {
  text-align: left;
}

::v-deep .table td:last-child,
::v-deep .table th:last-child {
  text-align: right;
}
</style>
